import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'mutationobserver-shim'
import './directives'
import './registerServiceWorker'
import './plugins'
// import './notifications/ask-permission'
// import 'maplibre-gl/dist/maplibre-gl.css'

import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import AppComponent from './App.vue'
import router from './router'
import store from './store'
import i18n from './config/i18n'
// import socketClient from './notifications/socket-client'
// import { defineCustomElements } from '@ionic/pwa-elements/loader'
// defineCustomElements(window)

const showFatalStartupError = error => {
  const mount = document.getElementById('app')
  if (!mount) {
    return
  }

  if (document.getElementById('fatal-startup-error')) {
    return
  }

  const message = error?.message || String(error || 'Unknown startup error')
  const wrapper = document.createElement('div')
  wrapper.id = 'fatal-startup-error'
  wrapper.style.padding = '16px'
  wrapper.style.margin = '16px'
  wrapper.style.border = '1px solid #ef4444'
  wrapper.style.borderRadius = '8px'
  wrapper.style.background = '#fff5f5'
  wrapper.style.color = '#991b1b'
  wrapper.style.fontFamily = 'monospace'
  wrapper.innerHTML = `<strong>UI startup error</strong><br>${message}`
  mount.innerHTML = ''
  mount.appendChild(wrapper)
}

Vue.config.errorHandler = (error, vm, info) => {
  console.error('Vue runtime error:', error, info, vm)
  showFatalStartupError(error)
}

window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled promise rejection:', event?.reason)
  showFatalStartupError(event?.reason)
})

Vue.use(VueApexCharts)
Vue.component('Apexchart', VueApexCharts)

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(AppComponent)
})

if (window.pdfjsLib?.GlobalWorkerOptions) {
  window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.4.456/pdf.worker.min.js'
}

// Vue.use(socketClient)

Vue.config.productionTip = false

app.$mount('#app')
